import React from "react";
import { Divider, Modal, Row, Col, Typography } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import SoldOutOverlay from "./SoldOutOverlay";
import Cart from "assets/activity/cartIcon.png";
import { convertTimeStamp } from "utility/functions/convertTimestamp";

const TICKET_TYPE_EXTERNAL = 16;

const ActivityModal = ({
  isModalOpen,
  setIsModalOpen,
  ticketIntro,
  openCharts,
  handleClickImg,
}) => {
  const { Paragraph } = Typography;
  const isExternalTicket = Number(ticketIntro?.type) === TICKET_TYPE_EXTERNAL;
  const actionIconClassName =
    "flex items-center justify-center border-0 text-black cursor-pointer rounded-md bg-white absolute mobile:w-9 mobile:h-9 tablet:w-10 tablet:h-10 tablet-portrait:w-10 tablet-portrait:h-10 desktop:w-10 desktop:h-10 tablet:top-4 tablet:right-6 tablet-portrait:top-4 tablet-portrait:right-6 desktop:top-4 desktop:right-6 mobile:top-2 mobile:right-3 mobile:scale-75 tablet:scale-90 tablet-portrait:scale-90 transition-all duration-300 ease-in-out hover:rounded-xl z-10";
  const ticketTimeText = isExternalTicket
    ? "時間細節以外部連結為主"
    : `${convertTimeStamp(
        ticketIntro.startDateTime,
        "MM/DD ddd - HH:mm"
      )}（opens at ${convertTimeStamp(
        ticketIntro.admissionStartDateTime,
        "HH:mm"
      )}）`;

  return (
    <Modal
      // title={`${t("activity.description")}`}
      open={isModalOpen}
      footer={null}
      onCancel={() => setIsModalOpen(false)}
      className="mobile:mx-auto mobile:w-11/12 mobile:[&_.ant-modal-content]:!p-[14px] mobile:[&_.ant-modal-body]:!p-0 [&_.ant-modal-title]:bg-SKF-G-004 [&_.ant-modal-title]:text-white [&_.ant-modal-close-x]:!text-2xl [&_.ant-modal-close-x]:text-white [&_.ant-modal-content]:bg-SKF-G-004 [&_.ant-modal-content]:!rounded-[20px] [&_.ant-modal-content]:overflow-hidden [&_.ant-modal-close]:!top-3 [&_.ant-modal-close]:!left-3 [&_.ant-modal-close]:!w-12 [&_.ant-modal-close]:!h-12 [&_.ant-modal-close]:!flex [&_.ant-modal-close]:!items-center [&_.ant-modal-close]:!justify-center"
    >
      <Row>
        <Col
          key={ticketIntro.id}
          lg={{ span: 24 }}
          xs={{ span: 24 }}
          sm={{ span: 24 }}
          className="transition ease-in-out delay-100  duration-200  mobile:px-1 tablet:px-2"
        >
          <div className="relative mt-8 mobile:mt-12">
            <picture className="block" key={ticketIntro.id}>
              <source
                media="(max-width: 520px)"
                srcSet={ticketIntro.mobile_url}
              />
              <img
                src={ticketIntro.cover}
                alt=""
                className="w-full aspect-square object-cover mobile:rounded-lg tablet:rounded-2xl tablet-portrait:rounded-2xl desktop:rounded-3xl"
              />
            </picture>

            {/* 售完顯示樣式 */}
            {ticketIntro.remainQuantity === 0 && <SoldOutOverlay />}

            {/* 剩餘數量 !== 0時，顯示票價，若否則顯示售完 */}
            <span
              className={`bg-white text-black p-2 rounded-3xl absolute tablet:top-4 tablet:left-6 tablet-portrait:top-4 tablet-portrait:left-6 desktop:top-4 desktop:left-6 mobile:top-3 mobile:left-4 mobile:py-1 z-10 ${
                ticketIntro.remainQuantity === 0 ? "hidden" : "block"
              }`}
            >
              NT＄{ticketIntro.price}
            </span>

            {/* 剩餘數量 !== 0時，顯示購物車icon */}
            {ticketIntro.remainQuantity !== 0 && (
              <>
                {isExternalTicket ? (
                  <button
                    type="button"
                    className={actionIconClassName}
                    onClick={() => openCharts(ticketIntro)}
                    aria-label="前往外部連結"
                  >
                    <ArrowRightOutlined className="text-base" />
                  </button>
                ) : (
                  <button
                    type="button"
                    className={actionIconClassName}
                    onClick={() => openCharts(ticketIntro)}
                    aria-label="加入購物車"
                  >
                    <img
                      src={Cart}
                      className="w-5 h-5 mobile:w-4 mobile:h-4 object-contain"
                      alt=""
                    />
                  </button>
                )}
              </>
            )}
          </div>

          {/* border-SKF-G-004 */}
          <div
            className="text-left mt-4"
            onClick={() => handleClickImg(ticketIntro)}
          >
            <p className="text-SKF-G-002 text-14 m-0 mb-1">{ticketTimeText}</p>
            <p className="m-0 text-white text-xl">{ticketIntro.title}</p>
          </div>

          <Divider className="border-SKF-G-003 my-4" />
          <Paragraph
            className="text-SKF-G-002"
            // ellipsis={{
            //   rows: 2,
            //   expandable: true,
            //   symbol: "展開",
            // }}
          >
            {ticketIntro?.introduction
              ?.split(/\r\n|\r|\n/)
              .map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  {index <
                    ticketIntro?.introduction?.split(/\r\n|\r|\n/).length -
                      1 && <br />}
                </React.Fragment>
              ))}
          </Paragraph>
        </Col>
      </Row>
    </Modal>
  );
};

export default ActivityModal;
